<template>
    <Sheet v-loading="loading.actions['menu']">
        <h2>{{routeTitle}}</h2>
        <el-button
                @click="showConfig = true"
                size="mini"
        >
            設定轉文字
        </el-button>
        <el-button
                @click="refresh"
                icon="el-icon-refresh"
                size="mini"
        >
            重新整理
        </el-button>
        <el-row :gutter="16" style="margin-top: 10px">
            <el-col :span="12">
                <h4>選項</h4>
                <div style="max-height: 1000px; overflow-y:auto; ">
                    <el-tree
                            :data="nodes"
                            :expand-on-click-node="false"
                            @node-click="onNodeClick"
                            default-expand-all
                            node-key="key"
                            style="background-color: azure;"
                    >
                        <template #default="{node, data}">
                        <span class="custom-tree-node">
                             <span>
                                 {{node.label}}
                             </span>
                            <span>
                                <el-button
                                        @click.stop="onAppend(data)" 
                                        size="mini"
                                        type="text"
                                        v-if="!data.isAuth && data.level < 3"
                                >
                                    {{!data.isRoot ? '新增子選單' :　'新增類別'}}
                                </el-button>
                                <el-button
                                        @click.stop="onDelete(data)"
                                        size="mini"
                                        type="text"
                                        v-if="!data.isRoot && !data.isAuth"
                                >
                                    刪除
                                </el-button>
                            </span>
                        </span>
                        </template>
                    </el-tree>
                </div>
            </el-col>
            <el-col :span="12">
                <h4>異動</h4>
                <template v-if="currentItem">
                    <el-form
                            :rules="rules"
                            label-width="120px"
                            :model="currentItem"
                            ref="form"
                            v-if="!currentItem.isRoot"
                    >
                        <el-form-item
                                label="選單編號"
                                prop="menuId"
                        >
                            <el-input
                                    :value="currentItem.menuId"
                                    readonly
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                                label="顯示名稱"
                                prop="title"
                        >
                            <el-input
                                    placeholder="請輸入名稱"
                                    v-model="currentItem.title"
                            ></el-input>
                        </el-form-item>

                        <el-form-item
                                label="停用?"
                                prop="isHidden"
                        >
                            <el-checkbox
                                    v-model="currentItem.isHidden"
                            ></el-checkbox>
                        </el-form-item>

                        <el-form-item
                                label="顯示順序(降冪)"
                                prop="sort"
                        >
                            <el-input-number
                                    :max="999"
                                    :min="0"
                                    size="mini"
                                    v-model="currentItem.sort"
                            ></el-input-number>
                        </el-form-item>
                        <el-divider>開放時間設定</el-divider>
                        <el-form-item
                                label="持續顯示"
                                prop="always"
                        >
                            <el-checkbox
                                    v-model="currentItem.always"
                            ></el-checkbox>
                        </el-form-item>

                        <el-form-item
                                label="開放起訖時間"
                                prop="range"
                                v-if="!currentItem.always"
                        >
                            <el-date-picker
                                    end-placeholder="結束時間"
                                    range-separator="至"
                                    start-placeholder="開始時間"
                                    type="datetimerange"
                                    v-model="currentItem.range"
                            ></el-date-picker>
                        </el-form-item>

                        <div style="width: 100%; text-align: right">
                            <el-button
                                    @click="onSubmit"
                                    size="mini"
                                    type="primary"
                            >
                                更新設定
                            </el-button>
                        </div>
                    </el-form>
                </template>
            </el-col>
        </el-row>
        <el-dialog
                title="複製設定"
                :visible.sync="showConfig"
        >
            <template #title>
                請將內容插入到routeConfig.js中
            </template>
            <el-input
                    type="textarea"
                    :value="configText"
                    rows="15"
                    readonly
                    ref="config"
            ></el-input>
            <template #footer>
                <el-button
                        icon="el-icon-document-copy"
                        @click="onCopy"
                >
                    複製
                </el-button>
            </template>
        </el-dialog>
    </Sheet>
</template>

<script>
    import moment from 'moment';
    import {mapActions, mapState} from 'vuex';
    import routeTitleMixin from './routeTitleMixin';
    import nodesMixin from './nodesMixin';

    export default {
        name: 'MenusSetting',
        mixins: [routeTitleMixin, nodesMixin],
        data: () => ({
            currentItem: undefined,
            showConfig: false,
            rules: {
                title: [
                    {required: true, message: '請輸入名稱', trigger: 'blur'},
                ],
                range: [
                    {required: true, message: '請選擇起訖'}
                ]
            }
        }),
        computed: {
            ...mapState('menu', ['menus']),
            ...mapState(['loading']),

            configText(){
                const text = JSON.stringify([...this.leave.map(l => ({
                    name: l.menuId,
                    component: '請取代為vue component',
                    path: '請取代為要設定的路徑',
                    meta:{requiresAuth: true},
                    exact:true
                }))]);

                return text.substring(1, text.length - 1);
            },
        },

        methods: {
            ...mapActions('menu', {
                getAll: 'getMenusAction',
                remove: 'removeMenuAction',
                add: 'addMenuAction',
                update: 'updateMenuAction',
            }),

            onCopy(){
                const configRef = this.$refs['config'];
                configRef.select();
                document.execCommand('copy');
                this.$message({
                    message:'已複製到剪貼簿囉!',
                    type: 'info'
                });
                this.showConfig = false;
            },

            onNodeClick(data) {
                this.currentItem = {
                    ...data.raw,
                    isRoot: data.isRoot,
                    range: data.isRoot ? [] : (data.raw.range || []).map(r => moment(r).toDate()),
                };
            },

            async onAppend(data) {
                const max =
                    this.menus
                        .filter(c => c.level === 1 && c.isAuth)
                        .map(m => parseInt(m.menuId))[0];

                const getItem = (level, parent, max) => {
                    const currentSiblings =
                        this
                            .menus
                            .filter(m =>
                                !m.isAuth && m.level === level
                                && (!parent || m.parent === parent)
                            )
                            .map(m => parseInt(m.menuId.substring(2 * (level - 1))))
                            .sort((a, b) => b - a);

                    const nextSn = currentSiblings.length === 0 ? 1 : currentSiblings[0] + 1;

                    if (nextSn >= max) return {valid: false};

                    const prefix = parent || '';

                    const menuId = `${prefix}${nextSn.toString().padStart(2, '0')}`;

                    return ({
                        item: {
                            menuId,
                            title: `選單${menuId}`,
                            sort: 0,
                            range: [
                                moment().format('YYYY-MM-DD hh:mm:ss'),
                                moment().format('YYYY-MM-DD hh:mm:ss')
                            ],
                            level: level,
                            isAuth: false,
                            isHidden: true,
                            always: false,
                            parent
                        },
                        valid: true
                    });
                };

                const nextLevel = data.isRoot ? 1 : data.level + 1;
                const parent = data.isRoot ? null : data.key;
                const m = data.isRoot ? max - 1 : max;
                const {valid, item} = getItem(nextLevel, parent, m);
                if (valid) {
                    const {success} = await this.add(item);
                } else {
                    this.$message({
                        message: `超過該層級可加的選單上限數量(上限: ${m})`,
                        type: 'warning'
                    })
                }
            },


            async onDelete(data) {
                const doRemove = async () => {
                    const {menuId} = data.raw;
                    const {success} = await this.remove(menuId);
                    if (success) {
                        this.$message.success('刪除成功');
                        this.currentItem = null;
                    } else {
                        this.$message.warning('刪除失敗，請重試一次');
                    }
                };
                const {children} = data;
                if (children.length > 0) {
                    try {
                        await this.$confirm('確定要刪除嗎?(會一併將子選單也刪除)', {
                            type: 'danger',
                        });
                        await doRemove();
                    } catch (e) {
                        if (e !== 'cancel') {
                            this.$message({
                                type: 'error',
                                message: '發生錯誤，請重試一次!'
                            });
                        }
                    }
                } else {
                    await doRemove();
                }
            },

            async onSubmit() {
                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {
                        const {success} = await this.update({
                            ...this.currentItem,
                        });

                        if (success) {
                            this.$message({
                                type: 'success',
                                message: '異動成功'
                            });
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '異動失敗，請重試一次'
                            });
                        }

                        this.currentItem = null;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                });

            },

            async refresh() {
                await this.getAll();
            }
        },

        async created() {
            await this.getAll();
        }
    }
</script>

<style scoped>
    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
</style>